import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack, Toggle} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import SearchableDropdown from "../../Components/SearchableDropdown";

function MovePayment(props) {
    const [user] = useContext(AuthContext);
    const [targets, setTargets] = useState([]);
    const [transaction, setTransaction] = useState(0);
    const [updateAccount, setUpdateAccount] = useState(false);

    const _submit = (e) => {
        e.preventDefault();
        const data = {update_account: updateAccount};
        fetch(`/api/payment/${props.add.id}/move/${transaction.key}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='MovePayment'>Przenieś</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setTransaction(0);
        if (props.add !== false) {
            async function fetchVentures() {
                await fetch(`/api/payment/${props.add.id}/move`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setTargets(data.map((item) => {
                            return {key: item.id, text: `${item.name}`};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }

            fetchVentures();
        } else {
            setTargets([]);
        }
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Przenieś Płatność"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='MovePayment'>
                <SearchableDropdown
                    label="Projekt"
                    selectedKey={transaction ? transaction.key : undefined}
                    onChange={(e, item) => setTransaction(item)}
                    placeholder="Wybierz z listy"
                    options={targets}
                />
                <Toggle label="Aktualizuj konto" onText="Tak" offText="Nie" onChange={(e, checked) => setUpdateAccount(checked)} />
            </form>
        </Panel>
    )
}

export default MovePayment;